import GameHelper from "@/utils/game-helper";

export default {
  computed: {
    gameStats() {
      if (!this.roundGames || !Array.isArray(this.roundGames)) {
        return {
          live: 0,
          bye: 0,
          matches: 0,
          unfinished: 0,
          finished: 0,
          aborted: 0,
          conflicted: 0,
        };
      }

      const live = this.roundGames.filter(
        (g) => g.matchRef && g.matchRef.status === "live"
      ).length;

      const bye = this.roundGames.filter(
        (g) => g.whiteUsername && !g.blackUsername
      ).length;

      const matches = this.roundGames.filter((g) => g.matchRef).length;

      const unfinished = this.roundGames.filter((g) =>
        GameHelper.isUnfinished(g)
      ).length;

      const finished = this.roundGames.filter(
        (g) =>
          g.matchRef &&
          g.matchRef.result &&
          g.matchRef.status !== "aborted" &&
          !this.hasResultMismatch(g) &&
          !this.hasPlayerMismatch(g)
      ).length;

      const aborted = this.roundGames.filter(
        (g) => g.matchRef && g.matchRef.status === "aborted"
      ).length;

      const conflicted = this.roundGames.filter(
        (g) =>
          !GameHelper.isUnfinished(g) &&
          (this.hasResultMismatch(g) || this.hasPlayerMismatch(g))
      ).length;

      return {
        live,
        bye,
        matches,
        unfinished,
        finished,
        aborted,
        conflicted,
      };
    },
  },

  methods: {
    hasPlayerMismatch(game) {
      return GameHelper.hasPlayerMismatch(game);
    },
  },
};
